'use client'

import { useEffect } from 'react'
import { useRouter } from 'next/navigation'

export default function HomePage() {
  const router = useRouter()

  useEffect(() => {
    // Redirect to login for static export
    router.replace('/login')
  }, [router])

  // Show redirect message
  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#f9fafb'
    }}>
      <div style={{
        textAlign: 'center'
      }}>
        <div style={{
          width: '48px',
          height: '48px',
          background: '#0d6efd',
          borderRadius: '12px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 16px',
          color: 'white',
          fontWeight: 'bold',
          fontSize: '20px'
        }}>PP</div>
        <p style={{ color: '#6b7280', fontSize: '14px' }}>Redirecting to login...</p>
      </div>
    </div>
  )
}
